import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeightCartService {
  private dataSubject = new BehaviorSubject<any>(null);
  private creditoAutorizadoSubject = new BehaviorSubject<any>(null);
  private creditoSuspendidoSubject = new BehaviorSubject<any>(null);
  private clienteSuspendidoSubject = new BehaviorSubject<any>(null);
  sharedVariableHeight: any;
  tipoDeCompra: any = false;
  creditoAutorizado: any;
  creditoSuspendido: any;
  activarKabikCoin: number;

  constructor() { }

  updateSharedVariableTipoCompra(tipoCompra: any) {
    this.tipoDeCompra = tipoCompra;
  }

  setData(data: any) {
    this.dataSubject.next(data);
  }

  getData(): Observable<any> {
    return this.dataSubject.asObservable();
  }

  updateSharedVariableCreditoAutorizado(creditoAutorizado: any) {
    this.creditoAutorizado = creditoAutorizado;
  }

  setDataCreditoAuth(data: any) {
    this.creditoAutorizadoSubject.next(data);
  }

  getDataCreditoAuth(): Observable<any> {
    return this.creditoAutorizadoSubject.asObservable();
  }

  updateSharedVariableCreditoSuspendido(creditoSuspendido: any) {
    this.creditoSuspendido = creditoSuspendido;
  }

  setDataCreditoSuspend(data: any) {
    this.creditoSuspendidoSubject.next(data);
  }

  getDataCreditoSuspend(): Observable<any> {
    return this.creditoSuspendidoSubject.asObservable();
  }

  setClienteSuspendo(data: any) {
    this.clienteSuspendidoSubject.next(data);
  }

  getClienteSuspendo(): Observable<any> {
    return this.clienteSuspendidoSubject.asObservable();
  }
}